import Navbar from "./components/Navbar";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import Thesis from "./components/pages/Thesis";
import BlueLoops from "./components/pages/BlueLoops";
import CaneaChat from "./components/pages/CaneaChat";
import FilmFriends from "./components/pages/FilmFriends";
import Bottombar from "./components/Bottombar";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/thesis" element={<Thesis />} />
        <Route path="/caneachat" element={<CaneaChat />} />
        <Route path="/filmfriends" element={<FilmFriends />} />
        <Route path="/blueloops" element={<BlueLoops />} />
      </Routes>
      <Bottombar></Bottombar>
    </Router>
  );
}

export default App;
